import { PROMO_ACTION_TYPES } from "./actionTypes";

const initialState = {
    loading: false,
    error: null,

    coupon: null,
    isApplied: false,

    discount: 0,

    appliedAt: null,
};

export const promoReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROMO_ACTION_TYPES.APPLY_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }

        case PROMO_ACTION_TYPES.APPLY_SUCCESS: {
            const { coupon, discount } = action.payload;

            return {
                ...state,
                loading: false,
                error: null,
                coupon: coupon,
                isApplied: true,
                discount: Number(discount) || 0,
                appliedAt: action.meta.timestamp,
            };
        }

        case PROMO_ACTION_TYPES.APPLY_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                isApplied: false,
            };
        }

        case PROMO_ACTION_TYPES.CLEAR_PROMO: {
            return initialState;
        }

        default:
            return state;
    }
};